import WRAP from 'WRAP-JS'
import { AIRWAY_LEVEL_BOTH, AIRWAY_LEVEL_HIGH, AIRWAY_LEVEL_LOW } from '../components/map/layers/Airway';
import WrapOption from "../constants/WrapOption";
import * as FPEUtils from "../utils/FPEUtils";

export const WRAPInitializer = () => {
  WRAP.DH.conf_path = "pri/conf/data";
  WRAP.DH.set(WrapOption());
  WRAP.Configuration.cache.size = 1024 * 1024 * 1024;
  extension();
  //dont draw anything
  return null;
}

const extension = () => {
  /* eslint-disable */
  WRAP.Renderer.GeoJSONExt = function() {
    WRAP.Renderer.call(this);

    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
      WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

      this.drawFlg = false;
      var current_zoom = -1;
      if ( context && context.tiles.length )
        current_zoom = context.zoom;

      var data_conf = data.configuration('data');
      if ( data_conf.update_interval && data_conf.auto_update === false )
        return;

      var dynamic = this.requireDynamicDraw(conf);
      if ( !dynamic ) {
        var tiled = data_conf.Grid && data_conf.Grid.MaxZoom;
        if ( !tiled ) {
          if ( !conf.Attributes.min_zoom ) {
            if ( this.content_revision == revision.content
              &&  this.conf_revision == revision.conf
              &&  this.style_revision == revision.style
              &&  this.data_revision == revision.data )
              return;
          }
          else {
            if ( this.last_zoom == current_zoom
              &&  this.content_revision == revision.content
              &&  this.conf_revision == revision.conf
              &&  this.style_revision == revision.style
              &&  this.data_revision == revision.data )
              return;
          }
        }
        else {
          if ( this.content_revision == revision.content
            &&  this.context_revision == revision.context
            &&  this.conf_revision == revision.conf
            &&  this.style_revision == revision.style
            &&  this.data_revision == revision.data )
            return;
        }
      }
      layer.setStatus({status:"invalid"});

      var tiles = null;
      if ( data_conf.retain ) {
        var geo = data.retained.data;
        if ( geo ) {
          tiles = Array.isArray(geo) ? geo : [geo];
        }
        else if ( data.status.data && data.status.data != 'completed' ) {
          layer.setStatus({status:"error", reason:data.status.data});
        }
      }
      else {
        if (current_zoom < conf.Attributes.min_zoom) {
          layer.clear();
          this.drawFlg = true;
          return;
        }
        var bounds = [];
        for ( var i = 0 ; i < context.tiles.length ; i++ ) {
          var tb = context.tiles[i].bounds;
          var b = {
            north:tb.north/60,
            south:tb.south/60,
            west:tb.west/60,
            east:tb.east/60
          }
          bounds.push(b)
        }
        var z = context.zoom;
        var dpt = 360/Math.pow(2,z);
        var sampling = "dpt "+dpt;
        tiles = this.getGeoObject(data, 'data', bounds, content, sampling, layer);
      }
      if ( !tiles )
        return;

      var features = [];
      for ( var i = 0 ; i < tiles.length ; i++ ) {
        var tile = tiles[i];
        if ( !tile ) continue;
        var fc = tile.features;
        if ( fc ) {
          for ( var j = 0 ; j < fc.length ; j++ )
            features.push(fc[j]);
        }
        else if ( tiles[i].type == "Feature" ) {
          features.push(tiles[i]);
        }
      }

      layer.clear();
      this.drawFlg = true;

      if ( !conf.Attributes.min_zoom || current_zoom >= conf.Attributes.min_zoom ) {
        var style_name = style||"default";
        var render_types = conf.Attributes.features;

        if ( conf.Attributes.sort ) this.sortItem(features, conf.Attributes.sort);

        for ( var i = 0 ; i < features.length ; i++ ) {
          var item = features[i];
          var geometry = item.geometry;
          if ( !geometry )
            continue;
          var prop = item.properties;
          if ( prop && prop.display_flag === false )
            continue;
          if ( conf.Attributes.filter && !conf.Attributes.filter(item, i, features) )
            continue;
          var ts = this.selectStyle(render_types, prop, style_name);
          if ( !ts )
            continue;
          this.drawFeature(layer, item, prop, ts);
        }
      }

      this.content_revision = revision.content;
      this.context_revision = revision.context;
      this.conf_revision = revision.conf;
      this.style_revision = revision.style;
      this.data_revision = revision.data;
      this.last_zoom = current_zoom;

      if ( layer.getStatus().status != 'error' )
        layer.setStatus({status:"valid"});
      WRAP.Geo.invalidate();
    }
  }

  WRAP.Renderer.AirwayLine = function() {
    WRAP.Renderer.GeoJSONExt.call(this);

    function addFeature(layer, feature, geo, data) {
      feature.geo = geo;
      feature.data = data;
      layer.addFeature(feature);
    }

    const superDraw = this.draw;
    let check;
    let level;
    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
      check = {};
      level = conf.Attributes.level && conf.Attributes.level() || AIRWAY_LEVEL_BOTH;
      superDraw.apply(this, arguments);
    }

    this.drawFeature = function(layer, item, prop, ts) {
      const geo = item;
      const style = ts;
      if ( prop.preferred_route_type ) {
        return;
      }
      if (!!check[prop.gid]) {
        return;
      }
      check[prop.gid] = true;

      const targetLevel = (function() {
        switch(level) {
          case AIRWAY_LEVEL_BOTH:
            return ['B', 'H', 'L'];
          case AIRWAY_LEVEL_HIGH:
            return ['B', 'H'];
          case AIRWAY_LEVEL_LOW:
            return ['B', 'L'];
          default:
            return ['B'];
        }
      })();
      let currentArray = [];
      const coordinates = prop.fixes.reduce((accumulator, currentValue, currentIndex) => {
        if (targetLevel.includes(prop.level.charAt(currentIndex))) {
          if (currentArray.length === 0) {
            accumulator.push(currentArray);
          }
          currentArray.push(currentValue);
        } else {
          if (currentArray.length !== 0) {
            currentArray.push(currentValue);
            currentArray = [];
          }
        }
        return accumulator;
      }, []);
      const featureLine = new WRAP.Geo.Feature.GeoLine({
        path: coordinates,
        strokeStyle: style.line_color,
        lineWidth: style.line_width,
        geodesic: true,
        method: style.line_method
      });
      addFeature(layer, featureLine, geo, undefined);

    }
  }

  WRAP.Renderer.AirwayLabel = function() {
    WRAP.Renderer.GeoJSONExt.call(this);

    const features = [];
    function addFeature(layer, feature, geo, data) {
      feature.geo = geo;
      feature.data = data;
      layer.addFeature(feature);
    }

    const makeArrowSymbol = (w, h, lr) => {
      const vp = 1;
      const hp = 5;
      const ah = h * 0.8;
      const aw = h * 2;
      let r, arrow;
      
      switch(lr) {
        case "l":
          r = 1;
          arrow = true;
          break;
        case "r":
          r = -1;
          arrow = true;
          break;
        default:
          r = 1;
          arrow = false;
          break;
      }

      const array = [
        [(-w / 2 - hp) * r, -h / 2 - vp], [(w / 2 + hp) * r, -h / 2 - vp],
        [(w / 2 + hp) * r, h / 2 + vp], [(-w / 2 - hp) * r, h / 2 + vp],
      ];
      if (arrow) {
        array.push(
          [(-w / 2 - hp) * r, aw / 2], [(-w / 2 - hp - ah) * r, 0], [(-w / 2 - hp) * r, -aw / 2]
        );
      }
      array.push(array.slice(0, 1)[0]);
      return array;
    }

    const getBoundingRect = (w, h, rotation) => {
      const array = makeArrowSymbol(w, h, "");
      const rad = FPEUtils.deg2rad(rotation);
      const cos = Math.cos(rad);
      const sin = Math.sin(rad);
      let minX, minY, maxX, maxY;
      array.forEach(v => {
        const x = v[0] * cos - v[1] * sin;
        const y = v[0] * sin + v[1] * cos;
        if (minX === undefined || minX > x) {
          minX = x;
        }
        if (maxX === undefined || maxX < x) {
          maxX = x;
        }
        if (minY === undefined || minY > y) {
          minY = y;
        }
        if (maxY === undefined || maxY < y) {
          maxY = y;
        }
      });
      return ([
        minX,
        minY,
        maxX - minX,
        maxY - minY
      ]);
    }

    const superDraw = this.draw;
    let buffer;
    let mask;
    let level;
    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
      buffer = {};
      level = conf.Attributes.level && conf.Attributes.level() || AIRWAY_LEVEL_BOTH;
      superDraw.apply(this, arguments);
      if (this.drawFlg) {
        features.splice(0);
        features.push.apply(features, Object.values(buffer));
      }
      mask = new WRAP.Geo.Mask(WRAP.Geo.currentView());
      mask.clear();
      layer.clear();
      features.forEach(val => {
        this._drawFeatureImpl(layer, val[0], val[1], val[2]);
      });
      WRAP.Geo.invalidate();
    }

    this.drawFeature = function(layer, item, prop, ts) {
      if ( prop.preferred_route_type ) {
        return;
      }
      buffer[prop.gid] = buffer[prop.gid] || [
        item,
        prop,
        ts
      ];
    }

    this._drawFeatureImpl = function(layer, item, prop, ts) {
      const geo = item;
      const style = ts;
      const text = prop.name;
      const s = Object.assign({
        font_size: 10,
        fill_color: "#000",
        label_color: "#fff",
      }, style);
      if (text !== undefined) {
        const textSize = WRAP.Geo.getTextMetrics(text, s.font_size);
        const fixes = item.properties.fixes;
        for (let i = 0; i < fixes.length; i++) {
          if (i === fixes.length - 1) continue;

          const targetLevel = (function() {
            switch(level) {
              case AIRWAY_LEVEL_BOTH:
                return ['B', 'H', 'L'];
              case AIRWAY_LEVEL_HIGH:
                return ['B', 'H'];
              case AIRWAY_LEVEL_LOW:
                return ['B', 'L'];
              default:
                return ['B'];
            }
          })();

          if (!targetLevel.includes(prop.level.charAt(i))) continue;

          const p1 = fixes[i];
          const p2 = fixes[i + 1];
          const p1xy = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(p1[1], p1[0]));
          const p2xy = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(p2[1], p2[0]));

          if (Math.pow(p1xy.x - p2xy.x, 2) + Math.pow(p1xy.y - p2xy.y, 2) < Math.pow(textSize[0] + textSize[1] * 2, 2)) {
            continue;
          }

          const gc = new WRAP.Geo.GreatCircle(p1[1], p1[0], p2[1], p2[0]);

          let flg = false;
          let point;
          let rotation;
          let correctedRotation;
          const candidates = (function() {
            if (Math.pow(p1xy.x - p2xy.x, 2) + Math.pow(p1xy.y - p2xy.y, 2) > Math.pow((textSize[0] + textSize[1] * 2) * 4, 2)) {
              return [0.5, 0.25, 0.75];
            }
            return [0.5];
          })();
          for (let i = 0; i < candidates.length; i++) {
            const t = candidates[i];
            const pt = gc.getPosition(t);
            point = [pt.lon, pt.lat];
            const pt1 = gc.getPosition(t - 0.1);
            const pt2 = gc.getPosition(t + 0.1);
            const xy1 = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(pt1.lat, pt1.lon));
            const xy2 = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(pt2.lat, pt2.lon));
            const xy  = WRAP.Geo.getScreenPoint(FPEUtils.convertWRAPPoint(pt.lat, pt.lon));
            const angle1 = Math.atan2(xy1.y - xy.y, xy1.x - xy.x);
            const angle2 = Math.atan2(xy.y - xy2.y, xy.x - xy2.x);
            const rotationRad = Math.atan2(
              Math.sin(angle1) + Math.sin(angle2),
              Math.cos(angle1) + Math.cos(angle2)
            );
            let correctedRotationRad = rotationRad;
            if (Math.cos(correctedRotationRad) < 0) {
              correctedRotationRad += Math.PI;
            }
            rotation = FPEUtils.rad2deg(rotationRad);
            correctedRotation = FPEUtils.rad2deg(correctedRotationRad);
            const rect = getBoundingRect(textSize[0], textSize[1], rotation);
            if (!mask.intersectRect(point, rect[0], rect[1], rect[2], rect[3])) {
              flg = true;
              mask.addRect(point, rect[0], rect[1], rect[2], rect[3]);
              break;
            }
          }
          if (!flg) continue;

          //矢印
          const dir = dir => {
            switch(dir) {
              case 'F':
                return 'l';
              case 'B':
                return 'r';
              default:
                return '';
            }
          }
          const featureArrow = new WRAP.Geo.Feature.Line({
            point: point,
            line: makeArrowSymbol(textSize[0], textSize[1], dir(item.properties.direction.charAt(i))),
            strokeStyle: false,
            fillStyle: s.fill_color,
            rotation: rotation,
          })
          addFeature(layer, featureArrow, geo, undefined);

          //ラベル
          const featureLabel = new WRAP.Geo.Feature.Text({
            point: point,
            offsetX: 0,
            offsetY: textSize[1] / 2 - 2,
            text: text,
            fontSize: s.font_size,
            fillStyle: s.label_color,
            strokeStyle: false,
            align: 'center',
            rotation: correctedRotation,
          });
          addFeature(layer, featureLabel, geo, undefined);
        }
      }
    }
  }

  WRAP.Geo.Renderer.FIRExt = function() {

    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
      WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

      var current_zoom = -1;
      if ( context && context.tiles.length )
        current_zoom = context.zoom;

      var tiled = data._handler().tiled();
      if ( !tiled ) {
        if ( !conf.Attributes.min_zoom ) {
          if ( this.content_revision == revision.content
            &&  this.conf_revision == revision.conf
            &&  this.style_revision == revision.style
            &&  this.data_revision == revision.data )
            return;
        }
        else {
          if ( this.last_zoom == current_zoom
            &&  this.content_revision == revision.content
            &&  this.conf_revision == revision.conf
            &&  this.style_revision == revision.style
            &&  this.data_revision == revision.data )
            return;
        }
      }
      else {
        if ( this.content_revision == revision.content
          &&  this.context_revision == revision.context
          &&  this.conf_revision == revision.conf
          &&  this.style_revision == revision.style
          &&  this.data_revision == revision.data )
          return;
      }

      layer.setStatus({status:"invalid"});

      var gd = data._handler().getData(content, context);
      if ( !gd ) {
        if ( data._handler()._error )
          layer.setStatus({status:"error", reason:data._handler()._error});
        data._handler().loadData(content, context, function() {
          WRAP.Geo.redraw(layer);
        });
        return;
      }

      var features = [];
      for ( var i = 0 ; i < gd.length ; i++ ) {
        var fc = gd[i].features;
        if ( fc ) {
          for ( var j = 0 ; j < fc.length ; j++ )
            features.push(fc[j]);
        }
        else if ( gd[i].type == "Feature" ) {
          features.push(gd[i]);
        }
      }

      layer.clear();

      var getArcPath = function(orgPoint,  start, end, radius, counterClockwise) {
        var path = [];

        //radius(nautical mile)
        var step = 1;
        if ( radius < 270 )
          step = 5;
        else if ( radius < 540 )
          step = 2;

        if (counterClockwise) {
          if (start < end)
            start += 360;
          for ( var r = start ; r > end ; r-=step ) {
            var pos = WRAP.Geo.Util.gcPos(orgPoint[1], orgPoint[0], r, radius);
            path.push([pos.lon, pos.lat]);
          }
        } else {
          if (end < start)
            end += 360;
          for ( var r = start ; r < end ; r+=step ) {
            var pos = WRAP.Geo.Util.gcPos(orgPoint[1], orgPoint[0], r, radius);
            path.push([pos.lon, pos.lat]);
          }
        }

        var pos = WRAP.Geo.Util.gcPos(orgPoint[1], orgPoint[0], end, radius);
        path.push([pos.lon, pos.lat]);
        return path;
      };

      if ( !conf.Attributes.min_zoom || current_zoom >= conf.Attributes.min_zoom ) {

        var style_name = style||"default";

        var render_types = conf.Attributes.features;
        var length = features.length;
        for ( var i = 0 ; i < length ; i++ ) {
          var item = features[i];
          var geometry = item.geometry;
          if ( !geometry )
            continue;
          var prop = item.properties;
          if ( prop && prop.display_flag === false )
            continue;

          var style = null;
          for ( var j = 0 ; j < render_types.length ; j++ ) {
            var selector = render_types[j].selector;
            if ( selector ) {
              if ( selector.type == "key_value" ) {
                if ( prop[selector.key] == selector.value ) {
                  style = render_types[j].style;
                  break;
                }
              }
            }
            else {
              style = render_types[j].style;
              break;
            }
          }

          var ts = style && style[style_name];
          if ( !ts )
            continue;

          for (var k = 0; k < geometry.coordinates.length; k++) {
            var rhumbline = prop.bdry_rl_idx ? prop.bdry_rl_idx[k] || [] : [];
            var counterClockwise = prop.bdry_cca ? (prop.bdry_cca[k] || []).map(function (o) {return o.idx }) : [];
            var clockwise = prop.bdry_ca ? (prop.bdry_ca[k] || []).map(function (o) { return o.idx}) : [];
            var ccIdx = 0, cIdx= 0;
            var method = [];
            var points = [];
            for (var l = 0; l < geometry.coordinates[k].length; l++) {
              points.push(geometry.coordinates[k][l]);
              if (rhumbline.indexOf(l) >= 0) {
                method.push('RL');
              } else if (counterClockwise.indexOf(l) >= 0) {
                method.push('GC');
                var cca = prop.bdry_cca[k][ccIdx].arc_org;
                var counterArcPath = getArcPath(cca.lonlat, cca.start, cca.end, cca.dist, true);
                counterArcPath.forEach(function (p) {
                  points.push(p);
                  method.push('GC');
                });
                ccIdx++;
              } else if (clockwise.indexOf(l) >= 0) {
                method.push('GC');
                var ca = prop.bdry_ca[k][cIdx].arc_org;
                var arcPath = getArcPath(ca.lonlat, ca.start, ca.end, ca.dist, false);
                arcPath.forEach(function (p) {
                  points.push(p);
                  method.push('GC');
                });
                cIdx++;
              } else {
                method.push('GC');
              }
            }
            method.pop();//last method is unnecessary

            if (points.length) {
              var feature = new WRAP.Geo.Feature.GeoLine({
                path: points,
                lineWidth: ts.line_width,
                strokeStyle: ts.line_color,
                fillStyle: ts.fill_color,
                fillImage: ts.fill_image,
                option: ts.option,
                method: method
              });
              feature.geo = item;
              layer.addFeature(feature);
            }
          }
        }
      }

      this.content_revision = revision.content;
      this.context_revision = revision.context;
      this.conf_revision = revision.conf;
      this.style_revision = revision.style;
      this.data_revision = revision.data;
      this.last_zoom = current_zoom;

      layer.setStatus({status:"valid"});
      WRAP.Geo.invalidate();

    };

  };


  WRAP.Geo.Renderer.ASCScaleExt = function() {

    this.draw = function(layer, content, conf, context, style, data, revision, dl) {

      var valid = true;
      if ( this.context_revision != revision.context ) {
        valid = false;
      }

      if ( this.content_revision != revision.content ) {
        valid = false;
      }

      if ( this.conf_revision != revision.conf ) {
        valid = false;
        dl.length = 0;
      }

      if ( valid )
        return;

      var s = conf.Attributes.style.default;
      if ( style && conf.Attributes.style[style] )
        s = conf.Attributes.style[style];
      if ( !s ) {
        layer.setStatus({status:"error", reason:"style definition error."});
        return;
      }

      layer.setStatus({status:"invalid", reason:"data load waiting."});

      var grid = data._handler().getGrid();
      if ( !grid )
        return;

      var gw = parseInt(grid.Width);
      var gh = parseInt(grid.Height);

      var sampling = "highest";
      if ( s.min_blocksize )
        sampling += (" "+s.min_blocksize);

      if ( !content || !content.element || !content.level )
        return;
      var element = Array.isArray(content.element)?content.element:[content.element];
      var level = Array.isArray(content.level)?content.level:[content.level];

      var rc = {};
      for ( var key in content ) {
        if ( key != 'element' && key != 'level' )
          rc[key] = content[key];
      }

      var tiles = []; // [elememt][level][tile]
      for ( var e = 0 ; e < element.length ; e++ ) {
        tiles[e] = [];
        for ( var l = 0 ; l < level.length ; l++ ) {
          tiles[e][l] = [];
        }
      }
      var waiting = false;
      for ( var i = 0 ; i < context.tiles.length ; i++ ) {
        var tile = context.tiles[i];
        for ( var e = 0 ; e < element.length ; e++ ) {
          rc.element = element[e];
          for ( var l = 0 ; l < level.length ; l++ ) {
            rc.level = level[l];
            var data_tile;
            if ( !(data_tile = data._handler().getTile(rc, tile.id, sampling)) ) {
              waiting = true;
              data._handler().loadTile(rc, tile.id, sampling, tile.z, tile.y, tile.x, tile.cood, tile.bounds,
                function() {
                  WRAP.Geo.redraw(layer);
                });
            }
            tiles[e][l][i] = data_tile;
          }
        }
      }
      if ( waiting )
        return;

      layer.clear();

      var step;
      var vm = new Uint8Array(gw*gh);
      var pos = [];
      /* priority
          ICE(1)=1
          CONV(1)=2
          ICE(2)=3
          TURB(3)=4
          CONV(2)=5
          TURB(4)=6
          TURB(5)=7
      */
      for ( var e = 0 ; e < element.length ; e++ ) {
        var ev = element[e];
        for ( var l = 0 ; l < level.length ; l++ ) {
          var el = tiles[e][l];
          for ( var i = 0 ; i < el.length ; i++ ) {
            var data = el[i].data;
            for ( var j = 0 ; j < data.length ; j++ ) {
              var v = data[j];
              if ( !v.value || isNaN(v.value) || !v.step )
                continue;
              var value = 0;
              if ( ev == 'ICING' ) {
                if ( v.value == 1 )
                  value = 1;
                else if ( v.value == 2 )
                  value = 3;
              }
              else if ( ev == 'CONV' ) {
                if ( v.value == 1 )
                  value = 2;
                else if ( v.value == 2 )
                  value = 5;
              }
              else if ( ev == 'TURB' ) {
                if ( v.value == 3 )
                  value = 4;
                else if ( v.value == 4 )
                  value = 6;
                else if ( v.value == 5 )
                  value = 7;
              }
              if ( value ) {
                var index = v.y*gw+v.x;
                if ( !vm[index] || vm[index] < value ) {
                  vm[index] = value ;
                  pos[index] = {lat:v.lat, lon:v.lon};
                  step = v.step;
                }
              }
            }
          }
        }
      }

      var iceLgtPath = [];
      var iceModPath = [];
      var convLgtPath = [];
      var convModPath = [];
      var turbModPath = [];
      var turbMod2SevPath = [];
      var turbSevPath = [];

      function getTargetItem(v) {
        var target;
        switch (v) {
          case 1:
            target = iceLgtPath;
            break;
          case 2:
            target = convLgtPath;
            break;
          case 3:
            target = iceModPath;
            break;
          case 4:
            target = turbModPath;
            break;
          case 5:
            target = convModPath;
            break;
          case 6:
            target = turbMod2SevPath;
            break;
          case 7:
            target = turbSevPath;
            break;
          default:
            target = []
        }
        return target;
      }

      if ( step ) {
        var gxd = parseFloat(grid.LonInterval)*step;
        var gyd = parseFloat(grid.LatInterval)*step;
        var gxh = gxd/2;
        var gyh = gyd/2;

        var i = 0;

        for ( var y = 0 ; y < gh ; y++ ) {
          var prevValue = -1;
          var prevX = -1;
          var itemPath = {}
          for ( var x = 0 ; x < gw ; x++ ) {
            var v = vm[i];
            if ( v !== 0 ) {
              var p = pos[i];
              var sx = p.lon-gxh;
              var ex = p.lon+gxh;
              var sy = p.lat+gyh;
              var ey = p.lat-gxh;

              if ( sy > 85  || ey < -85 ) {
                i++;
                continue;
              }

              //Featureの数を削減するため、隣り合うblockと同じvalueの場合はグルーピングする
              if (prevValue === -1 || prevValue === 0) {
                itemPath = {sx: sx, ex:ex, sy:sy, ey:ey};
              } else if (prevValue === v && x -1 === prevX) {
                //グルーピング
                itemPath.ex = ex;
              } else {
                //隣と値が変わっているため、書き出し対象に追加
                getTargetItem(prevValue).push(
                  [[itemPath.sx, itemPath.sy], [itemPath.ex, itemPath.sy], [itemPath.ex, itemPath.ey], [itemPath.sx, itemPath.ey], [itemPath.sx, itemPath.sy]]
                );
                itemPath = {sx: sx, ex:ex, sy:sy, ey:ey};
              }
            } else {
              if (prevValue > 0) {
                //隣と値が変わっているため、書き出し対象に追加
                getTargetItem(prevValue).push(
                  [[itemPath.sx, itemPath.sy], [itemPath.ex, itemPath.sy], [itemPath.ex, itemPath.ey], [itemPath.sx, itemPath.ey], [itemPath.sx, itemPath.sy]]
                );
              }
            }
            prevX = x;
            prevValue = v;
            i++;
          }
          //xの最後を書き出し対象に追加
          if (prevValue > 0) {
            getTargetItem(prevValue).push(
              [[itemPath.sx, itemPath.sy], [itemPath.ex, itemPath.sy], [itemPath.ex, itemPath.ey], [itemPath.sx, itemPath.ey], [itemPath.sx, itemPath.sy]]
            );
          }
        }
      }

      if (iceLgtPath.length) {
        layer.addFeature(new WRAP.Geo.Feature.GeoLine({
          path:iceLgtPath,
          fillStyle: s.icing_lgt_color,
          method: "RL"
        }));
      }

      if (iceModPath.length) {
        layer.addFeature(new WRAP.Geo.Feature.GeoLine({
          path:iceModPath,
          fillStyle: s.icing_mod_color,
          method: "RL"
        }));
      }

      if (convLgtPath.length) {
        layer.addFeature(new WRAP.Geo.Feature.GeoLine({
          path:convLgtPath,
          fillStyle: s.conv_lgt_color,
          method: "RL"
        }));
      }

      if (convModPath.length) {
        layer.addFeature(new WRAP.Geo.Feature.GeoLine({
          path:convModPath,
          fillStyle: s.conv_mod_color,
          method: "RL"
        }));
      }

      if (turbModPath.length) {
        layer.addFeature(new WRAP.Geo.Feature.GeoLine({
          path:turbModPath,
          fillStyle: s.turb_mod_color,
          method: "RL"
        }));
      }

      if (turbMod2SevPath.length) {
        layer.addFeature(new WRAP.Geo.Feature.GeoLine({
          path:turbMod2SevPath,
          fillStyle: s.turb_mod_to_sev_color,
          method: "RL"
        }));
      }

      if (turbSevPath.length) {
        layer.addFeature(new WRAP.Geo.Feature.GeoLine({
          path:turbSevPath,
          fillStyle: s.turb_sev_color,
          method: "RL"
        }));
      }

      // Check Grid Rank
      var check = false;
      if ( check) {
        var i = 0;
        for ( var y = 0 ; y < gh ; y++ ) {
          for ( var x = 0 ; x < gw ; x++ ) {
            var v = vm[i];
            if ( v ) {
              var p = pos[i];
              var feature;
              feature = new WRAP.Geo.Feature.Text({
                point:[p.lon,p.lat],
                text:v,
                fontSize:12,
                fillStyle:'#000',
                offsetX:0,
                offsetY:6,
                align:'center'
              });
              layer.addFeature(feature);
            }
            i++;
          }
        }
      }

      this.context_revision = revision.context;
      this.content_revision = revision.content;
      this.conf_revision = revision.conf;
      layer.setStatus({status:"valid"});
      WRAP.Geo.invalidate();
    }
  }

  WRAP.Renderer.TropicalStormExt = function() {
    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
      WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);
      
      var valid = true;
      if ( this.conf_revision != revision.conf ) {
        valid = false;
      }
      
      if ( this.style_revision != revision.style ) {
        valid = false;
      }
      
      if ( this.data_revision != revision.data ) {
        valid = false;
      }
      
      if ( valid )
        return;
      
      layer.setStatus({status:"invalid", reason:"data load waiting."});

      var root = data.retained.data;
      if ( !root ) {
        if ( data.status.index || data.status.data )
          layer.setStatus({status:"error", reason:"data load error."});
        return;
      }

      if ( data.status.data != 'completed' )
        layer.setStatus({status:"error", reason:"data load error."});
      
      var s = conf.Attributes;
      if ( s.show_forcast_track !== undefined )
        s.show_forecast_track = s.show_forcast_track;
      if ( s.show_forcast_wind_radii !== undefined )
        s.show_forecast_wind_radii = s.show_forcast_wind_radii;
      
      function drawLine(p, r1, r2, dir, line_color, line_width, f) {
        if ( !r1 && !r2 )
          return;
        var s = WRAP.Geo.getGCPoint(p, r1, dir);
        var e = WRAP.Geo.getGCPoint(p, r2, dir);
        var feature = new WRAP.Geo.Feature.GeoLine({
          path:[[s.lonDegree(),s.latDegree()],[e.lonDegree(),e.latDegree()]],
          strokeStyle:line_color,
          lineWidth:line_width
        });
        feature.geo = f;
        layer.addFeature(feature);
      }
      
      function drawWindSector(point, prop, f) {
        var factor = 1852;
        const offsetDeg = 0.05;
        var stmrds_gale_1  = prop.stmrds_gale_1  || 0;
        var stmrds_gale_2  = prop.stmrds_gale_2  || 0;
        var stmrds_gale_3  = prop.stmrds_gale_3  || 0;
        var stmrds_gale_4  = prop.stmrds_gale_4  || 0;
        var stmrds_storm_1 = prop.stmrds_storm_1 || 0;
        var stmrds_storm_2 = prop.stmrds_storm_2 || 0;
        var stmrds_storm_3 = prop.stmrds_storm_3 || 0;
        var stmrds_storm_4 = prop.stmrds_storm_4 || 0;
        var stmrds_hurricane_1 = prop.stmrds_hurricane_1 || 0;
        var stmrds_hurricane_2 = prop.stmrds_hurricane_2 || 0;
        var stmrds_hurricane_3 = prop.stmrds_hurricane_3 || 0;
        var stmrds_hurricane_4 = prop.stmrds_hurricane_4 || 0;
        var stmrda_gale_1  = prop.stmrda_gale_1  || 0;
        var stmrda_gale_2  = prop.stmrda_gale_2  || 0;
        var stmrda_gale_3  = prop.stmrda_gale_3  || 0;
        var stmrda_gale_4  = prop.stmrda_gale_4  || 0;
        var stmrda_storm_1 = prop.stmrda_storm_1 || 0;
        var stmrda_storm_2 = prop.stmrda_storm_2 || 0;
        var stmrda_storm_3 = prop.stmrda_storm_3 || 0;
        var stmrda_storm_4 = prop.stmrda_storm_4 || 0;
        var stmrda_hurricane_1 = prop.stmrda_hurricane_1 || 0;
        var stmrda_hurricane_2 = prop.stmrda_hurricane_2 || 0;
        var stmrda_hurricane_3 = prop.stmrda_hurricane_3 || 0;
        var stmrda_hurricane_4 = prop.stmrda_hurricane_4 || 0;
        var wind_line_color_gale      = s.wind_line_color_gale;
        var wind_line_color_storm     = s.wind_line_color_storm;
        var wind_line_color_hurricane = s.wind_line_color_hurricane;
        var wind_fill_color_gale      = s.wind_fill_color_gale;
        var wind_fill_color_storm     = s.wind_fill_color_storm;
        var wind_fill_color_hurricane = s.wind_fill_color_hurricane;
        
        var r_gale_1  = stmrds_gale_1*factor;
        var r_gale_2  = stmrds_gale_2*factor;
        var r_gale_3  = stmrds_gale_3*factor;
        var r_gale_4  = stmrds_gale_4*factor;
        var r_storm_1 = stmrds_storm_1*factor;
        var r_storm_2 = stmrds_storm_2*factor;
        var r_storm_3 = stmrds_storm_3*factor;
        var r_storm_4 = stmrds_storm_4*factor;
        var r_hurricane_1 = stmrds_hurricane_1*factor;
        var r_hurricane_2 = stmrds_hurricane_2*factor;
        var r_hurricane_3 = stmrds_hurricane_3*factor;
        var r_hurricane_4 = stmrds_hurricane_4*factor;
          
        if ( r_gale_1 ) {
            var feature = new WRAP.Geo.Feature.GeoArc({
                point:point,
                radius:r_gale_1,
                start:stmrda_gale_1,
                end:stmrda_gale_2 + offsetDeg,
                strokeStyle:wind_line_color_gale,
                lineWidth:s.wind_line_width,
                fillStyle:wind_fill_color_gale,
            });
            feature.geo = f;
            layer.addFeature(feature);
        }
        if ( r_gale_2 ) {
            var feature = new WRAP.Geo.Feature.GeoArc({
                point:point,
                radius:r_gale_2,
                start:stmrda_gale_2,
                end:stmrda_gale_3 + offsetDeg,
                strokeStyle:wind_line_color_gale,
                lineWidth:s.wind_line_width,
                fillStyle:wind_fill_color_gale,
            });
            feature.geo = f;
            layer.addFeature(feature);
        }
        if ( r_gale_3 ) {
            var feature = new WRAP.Geo.Feature.GeoArc({
                point:point,
                radius:r_gale_3,
                start:stmrda_gale_3,
                end:stmrda_gale_4 + offsetDeg,
                strokeStyle:wind_line_color_gale,
                lineWidth:s.wind_line_width,
                fillStyle:wind_fill_color_gale,
            });
            feature.geo = f;
            layer.addFeature(feature);
        }
        if ( r_gale_4 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_gale_4,
            start:stmrda_gale_4,
            end:stmrda_gale_1+360 + offsetDeg,
            strokeStyle:wind_line_color_gale,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_gale,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
          
        var p = new WRAP.Geo.Point(point[1]*60.0, point[0]*60.0);
        drawLine(p, r_gale_1, r_gale_4, stmrda_gale_1, wind_line_color_gale, s.wind_line_width, f);
        drawLine(p, r_gale_1, r_gale_2, stmrda_gale_2, wind_line_color_gale, s.wind_line_width, f);
        drawLine(p, r_gale_2, r_gale_3, stmrda_gale_3, wind_line_color_gale, s.wind_line_width, f);
        drawLine(p, r_gale_3, r_gale_4, stmrda_gale_4, wind_line_color_gale, s.wind_line_width, f);

        if ( r_storm_1 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_storm_1,
            start:stmrda_storm_1,
            end:stmrda_storm_2,
            strokeStyle:wind_line_color_storm,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_storm,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
        if ( r_storm_2 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_storm_2,
            start:stmrda_storm_2,
            end:stmrda_storm_3,
            strokeStyle:wind_line_color_storm,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_storm,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
        if ( r_storm_3 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_storm_3,
            start:stmrda_storm_3,
            end:stmrda_storm_4,
            strokeStyle:wind_line_color_storm,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_storm,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
        if ( r_storm_4 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_storm_4,
            start:stmrda_storm_4,
            end:stmrda_storm_1+360,
            strokeStyle:wind_line_color_storm,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_storm,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
          
        drawLine(p, r_storm_1, r_storm_4, stmrda_storm_1, wind_line_color_storm, s.wind_line_width, f);
        drawLine(p, r_storm_1, r_storm_2, stmrda_storm_2, wind_line_color_storm, s.wind_line_width, f);
        drawLine(p, r_storm_2, r_storm_3, stmrda_storm_3, wind_line_color_storm, s.wind_line_width, f);
        drawLine(p, r_storm_3, r_storm_4, stmrda_storm_4, wind_line_color_storm, s.wind_line_width, f);
          
        if ( r_hurricane_1 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_hurricane_1,
            start:stmrda_hurricane_1,
            end:stmrda_hurricane_2,
            strokeStyle:wind_line_color_hurricane,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_hurricane,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
        if ( r_hurricane_2 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_hurricane_2,
            start:stmrda_hurricane_2,
            end:stmrda_hurricane_3,
            strokeStyle:wind_line_color_hurricane,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_hurricane,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
        if ( r_hurricane_3 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_hurricane_3,
            start:stmrda_hurricane_3,
            end:stmrda_hurricane_4,
            strokeStyle:wind_line_color_hurricane,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_hurricane,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
        if ( r_hurricane_4 ) {
          var feature = new WRAP.Geo.Feature.GeoArc({
            point:point,
            radius:r_hurricane_4,
            start:stmrda_hurricane_4,
            end:stmrda_hurricane_1+360,
            strokeStyle:wind_line_color_hurricane,
            lineWidth:s.wind_line_width,
            fillStyle:wind_fill_color_hurricane,
          });
          feature.geo = f;
          layer.addFeature(feature);
        }
          
        drawLine(p, r_hurricane_1, r_hurricane_4, stmrda_hurricane_1, wind_line_color_hurricane, s.wind_line_width, f);
        drawLine(p, r_hurricane_1, r_hurricane_2, stmrda_hurricane_2, wind_line_color_hurricane, s.wind_line_width, f);
        drawLine(p, r_hurricane_2, r_hurricane_3, stmrda_hurricane_3, wind_line_color_hurricane, s.wind_line_width, f);
        drawLine(p, r_hurricane_3, r_hurricane_4, stmrda_hurricane_4, wind_line_color_hurricane, s.wind_line_width, f);
      }
      
      layer.clear();

      for ( var id in root ) {
        var geo = root[id];
        if ( !geo.features )
          continue;
        if ( geo.display_flag === false )
          continue;
        var track = [];
        var forecast = [];
        for ( var i = 0 ; i < geo.features.length ; i++ ) {
          var f = geo.features[i];
          var prop = f.properties;
          prop.id = id;
          var type = prop.wrap_feature_type;
          var point = f.geometry.coordinates;
          if ( type == 'track' )
            track.push(point);
          else if ( type == 'forecast' )
            forecast.push(point);
        }
        for ( var i = 0 ; i < geo.features.length ; i++ ) {
          var f = geo.features[i];
          var prop = f.properties;
          var type = prop.wrap_feature_type;
          var point = f.geometry.coordinates;
          if ( type == 'analysis' ) {
            track.push(point);
            forecast.unshift(point);
          }
        }
        
        var active_type = ['analysis'];
          
        if ( s.show_track_history === undefined || s.show_track_history === true ) {
          active_type.push('track');
          var feature = new WRAP.Geo.Feature.GeoLine({
            path:track,
            strokeStyle:s.track_history_line_color,
            lineWidth:s.track_history_line_width
          });
          layer.addFeature(feature);
        }
        if ( s.show_forecast_track === undefined || s.show_forecast_track === true ) {
          active_type.push('forecast');
          var feature = new WRAP.Geo.Feature.GeoLine({
            path:forecast,
            strokeStyle:s.forecst_track_line_color,
            lineWidth:s.forecst_track_line_width
          });
          layer.addFeature(feature);
        }

        var rollback_feature = null;
        if ( !s.track_circle_time ) {
          if ( s.show_analysis_wind_radii === undefined || s.show_analysis_wind_radii === true ) {
            for ( var i = 0 ; i < geo.features.length ; i++ ) {
              var f = geo.features[i];
              var prop = f.properties;
              if ( prop.wrap_feature_type == 'analysis' ) {
                var point = f.geometry.coordinates;
                drawWindSector(point, prop, f);
              }
            }
          }
          if ( s.show_forecast_track === undefined || s.show_forecast_track === true ) {
            if ( s.show_forecast_wind_radii === undefined || s.show_forecast_wind_radii === true ) {
              for ( var i = 0 ; i < geo.features.length ; i++ ) {
                var f = geo.features[i];
                var prop = f.properties;
                if ( prop.wrap_feature_type == 'forecast' ) {
                  var point = f.geometry.coordinates;
                  drawWindSector(point, prop, f);
                }
              }
            }
          }
        }
        else {
          var ct = new WRAP.Core.DateTime(s.track_circle_time);
          var ld = Number.MIN_SAFE_INTEGER;
          for ( var i = 0 ; i < geo.features.length ; i++ ) {
            var f = geo.features[i];
            var prop = f.properties;
            if ( prop.valid ) {
              var d = ct.diff(new WRAP.Core.DateTime(prop.valid));
              if ( d <= 0 && ld < d ) {
                ld = d;
                rollback_feature = f;
              }
            }
          }
          if ( rollback_feature ) {
            var point = rollback_feature.geometry.coordinates;
            var prop = rollback_feature.properties;
            drawWindSector(point, prop);
          }
        }

        if ( s.show_datetime === undefined || s.show_datetime === true ) {
          for ( var i = 0 ; i < geo.features.length ; i++ ) {
            var f = geo.features[i];
            var prop = f.properties;
            if ( active_type.indexOf(prop.wrap_feature_type) < 0 )
              continue;
            if ( !s.track_circle_time ) {
              if ( prop.wrap_feature_type == 'track' )
                continue;
            }
            else {
              if ( f != rollback_feature )
                continue;
            }
            var date = prop.valid;
            if ( date && date.length >= 11 ) {
              var text = "";
              var date_format_bylocale = s.date_format_bylocale;
              var date_format = s.date_format;
              if (date_format_bylocale) {
                const wdate = new WRAP.Core.DateTime(date);
                if(date_format_bylocale.indexOf('z[Z]')) {
                  text = wdate.format(date_format_bylocale.replace('z[Z]', 'z'), WRAP.Core.timezone);
                  if (text)
                    text = text.replace(' UTC', 'Z');
                } else {
                  text = wdate.format(date_format_bylocale, WRAP.Core.timezone);
                }
              } else if ( date_format ) {
                var u_year = 0, u_mon = 0, u_day = 0, u_hour = 0, u_min = 0, u_sec = 0;
                u_year = parseInt(date.substr(0,4));
                u_mon = parseInt(date.substr(4,2));
                u_day = parseInt(date.substr(6,2));
                u_hour = parseInt(date.substr(9,2));
                u_min = parseInt(date.substr(11,2));
                if ( date.length >= 13 )
                  u_sec = parseInt(date.substr(13,2));
                text = WRAP.Geo.formatTime(date_format, u_year, u_mon, u_day, u_hour, u_min, u_sec);
              }
              else {
                text = date.substr(6,2);
                text += " / ";
                text += date.substr(9,2);
                text += "Z";
              }
              var font_size = s.label_font_size || 12;
              var point = f.geometry.coordinates;
              var feature = new WRAP.Geo.Feature.Text({
                text:text,
                point:point,
                strokeStyle:s.label_edge_color,
                fillStyle:s.label_text_color,
                offsetX:s.label_offset_x,
                offsetY:s.label_offset_y,
                align:'left',
                fontSize:font_size
              });
              feature.geo = f;
              layer.addFeature(feature);
            }
          }
        }
        for ( var i = 0 ; i < geo.features.length ; i++ ) {
          var f = geo.features[i];
          var prop = f.properties;
          if ( active_type.indexOf(prop.wrap_feature_type) < 0 )
            continue;
          //if ( prop.wrap_feature_type == 'analysis' && active_type.length == 1 )
          //  continue;
          var type = prop.class;
          var point = f.geometry.coordinates;

          var icon = s.icon[type];
          if ( s.icon[prop.wrap_feature_type] ) {
            if ( s.icon[prop.wrap_feature_type].icon )
              icon = s.icon[prop.wrap_feature_type].icon;
            if ( s.icon[prop.wrap_feature_type].class_icon && s.icon[prop.wrap_feature_type].class_icon[type] )
              icon = s.icon[prop.wrap_feature_type].class_icon[type];
          }
          if ( point[1] < 0 && s.icon_south ) {
            if ( s.icon_south[type] )
              icon = s.icon_south[type];
            if ( s.icon_south[prop.wrap_feature_type] ) {
              if ( s.icon_south[prop.wrap_feature_type].icon )
                icon = s.icon_south[prop.wrap_feature_type].icon;
              if ( s.icon_south[prop.wrap_feature_type].class_icon && s.icon_south[prop.wrap_feature_type].class_icon[type] )
                icon = s.icon_south[prop.wrap_feature_type].class_icon[type];
            }
          }
          if ( s.custom_icon_time && s.custom_icon ) {
            if ( (prop.wrap_feature_type == 'analysis' && s.custom_icon_time == prop.wrap_feature_type)
              || prop.valid == s.custom_icon_time )
              icon = s.custom_icon;
          }
          if ( icon ) {
            var feature = new WRAP.Geo.Feature.Image({
              image:icon,
              point:point,
              width:s.icon_width,
              height:s.icon_height,
              offsetX:s.icon_offset_x,
              offsetY:s.icon_offset_y,
            });
            feature.geo = f;
            layer.addFeature(feature);
          }
        }
      }
      
      this.conf_revision = revision.conf;
      this.style_revision = revision.style;
      this.data_revision = revision.data;
      if ( layer.getStatus().status != 'error' )
        layer.setStatus({status:"valid"});
      WRAP.Geo.invalidate();
    }
  };

  WRAP.Geo.Screen = function() {

    if (!WRAP.Geo.Screen.initizalied) {
      WRAP.Geo.Screen.screens = [];
      const view = WRAP.Geo.currentView();
      Object.defineProperty(view, 'context_sealed', {
        get() {
          return this._context_sealed;
        },
        set(newValue) {
          const oldValue = this._context_sealed;
          this._context_sealed = newValue;
          if (newValue && oldValue !== newValue) {
            WRAP.Geo.Screen.screens.forEach(screen => {
              const newSVGString = screen.ctx.join('');
              if (newSVGString !== screen.latestSVGString) {
                screen.svg.innerHTML = '';
                screen.svg.innerHTML = newSVGString;
                screen.latestSVGString = newSVGString;
              }
            });
            WRAP.Geo.Screen.screens.splice(0);
          }
        }
      });
      WRAP.Geo.Screen.initizalied = true;
    }
    const svg = this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    this.ctx = [];
    Object.assign(svg.style, {
      position: 'absolute',
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      // zIndex: -1,
      // opacity: 0,
    });
    document.getElementById('map').appendChild(svg);
    this.id_bias = 1000;
    let dispatch = true;
    if (dispatch) {
      const parent = document.getElementById('map');
      const map_canvas = parent.getElementsByTagName('canvas')[0];
      ['mousedown', 'mousemove', 'mouseup'].forEach(eventType => {
        svg.addEventListener(eventType, event => {
          const eventCopy = document.createEvent("MouseEvents");
          eventCopy.initMouseEvent(event.type, event.bubbles, event.cancelable, event.view, event.detail,
            event.pageX || event.layerX, event.pageY || event.layerY, event.clientX, event.clientY, event.ctrlKey, event.altKey,
            event.shiftKey, event.metaKey, event.button, event.relatedTarget);
          map_canvas.dispatchEvent(eventCopy);
        })
      });
      [/* 'DOMMouseScroll',  */'mousewheel'/* , 'wheel' */].forEach(eventType => {
        svg.addEventListener(eventType, event => {
          const eventCopy = new WheelEvent(eventType, {
            deltaX: event.deltaX,
            deltaY: event.deltaY,
            deltaZ: event.deltaZ,
            deltaMode: event.deltaMode,
            wheelDelta: event.wheelDelta,
            detail: event.detail
          });
          map_canvas.dispatchEvent(eventCopy);
        })
      });
    }

    this.init = function(view) {
      // console.log('init');
      WRAP.Geo.Screen.screens.push(this);
      this.start = new Date();
      this.view = view;
      this.projection = view.projection;
      this.zoom = view.context.zoom;
      this.map_scale = view.context.map_scale;
      this.extent = view.context.extent;
      this.origin = view.context.origin;
              
      this.svg.setAttributeNS(null, 'viewBox', [0, 0, this.extent[0], this.extent[1]].join(' '));
      this.ctx.splice(0);
      this.features = [];
      this.tile_surface = -1;

      this._fragmentPath = WRAP.Geo.Context.prototype._fragmentPath;
      this._linearize = WRAP.Geo.Context.prototype._linearize;
      this.linearize = WRAP.Geo.Context.prototype.linearize;
    }
  }

  Object.assign(WRAP.Geo.Screen.prototype, {
    set: function(feature, tiled) {
      if ( feature.layer && feature.layer._disableInteraction )
        return;
      var id = this.features.length+this.id_bias;
      this.features.push({feature:feature, tiled:tiled, id:id, index:this.view.seal_count++});
      if ( tiled )
        this.tile_surface = this.features.length-1;
      return tiled?null:id;
    },

    get: function(p) {
      let id = -1;

      const point = this.svg.createSVGPoint();
      point.x = p[0];
      point.y = p[1];
      let intersects;
      if (typeof this.svg.getIntersectionList === 'function') {
        const irect = this.svg.createSVGRect();
        irect.width = irect.height = 1;
        irect.x = p[0];
        irect.y = p[1];
        intersects = this.svg.getIntersectionList(irect, null);
      } else {
        intersects = this.svg.childNodes;
      }
      for (let i = intersects.length - 1; i >= 0; i--) {
        const elem = intersects[i];
        const stroke = elem.getAttributeNS(null, 'stroke');
        const fill = elem.getAttributeNS(null, 'fill');
        if (stroke && stroke !== 'none' && elem.isPointInStroke(point) || fill && fill !== 'none' && elem.isPointInFill(point)) {
          id = elem.getAttributeNS(null, 'feature') - this.id_bias;
          break;
        }
      }

      if ( id < this.tile_surface )
        id = this.tile_surface;
      if ( id >= 0 && id < this.features.length )
        return { feature:this.features[id].feature, pixel:(id==this.tile_surface), index:this.features[id].index };
      return null;
    },

    drawImageData: function(feature, point, imageData, width, height, offset_x, offset_y, rotation) {
      WRAP.Geo.check(imageData);
      var color = this.set(feature);
      if (!color) return;
  
      const _drawCanvas = (ctx, ox, oy, width, height) => {
        const attr = [];
        if ( rotation ) {
          const transform = [];
          transform.push(`rotate(${rotation}, ${ox}, ${oy})`);
          attr.push(['transform', transform.join(' ')]);
        }
        attr.push(['x', ox+offset_x]);
        attr.push(['y', oy+offset_y]);
        attr.push(['width', width]);
        attr.push(['height', height]);
        attr.push(['fill', 'yellow']);
        attr.push(['feature', color]);
        ctx.push(
          `<rect ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
        );
      }
      
      var ctx = this.ctx;
      ctx.fillStyle = color;
      var p = this.view.renderPoint(point);
      var ox = p[0];
      var oy = p[1];
      
      var size = (width>height?width:height)*1.5;
      var sx = -size;
      var ex = this.svg.viewBox.baseVal.width+size;
      var sy = -size;
      var ey = this.svg.viewBox.baseVal.height+size;
      if ( oy < sy || ey < oy )
        return;
      if ( sx <= ox && ox <= ex )
        _drawCanvas(ctx, ox, oy, width, height);
      if ( this.view.band ) {
        var lox = ox - this.view.band;
        if ( sx <= lox && lox <= ex )
          _drawCanvas(ctx, lox, oy, width, height);
        var rox = ox + this.view.band;
        if ( sx <= rox && rox <= ex )
          _drawCanvas(ctx, rox, oy, width, height);
      }
    },

    drawImage: function(feature, point, url, width, height, offset_x, offset_y, rotation) {
      var img = WRAP.Geo.Cache.image(url);
      if ( !img )
        return;
  
      if ( !width )
        width = img.width;
      if ( !height )
        height = img.height;
      if ( offset_x === undefined )
        offset_x = -width/2;
      if ( offset_y === undefined )
        offset_y = -height/2;
  
      if ( Array.isArray(point[0]) ) {
        for ( var i = 0 ; i < point.length ; i++ )
          this.drawImageData(feature, point[i], img, width, height, offset_x, offset_y, rotation);
      }
      else {
        this.drawImageData(feature, point, img, width, height, offset_x, offset_y, rotation);
      }
    },

    _drawLines: function(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option) {
      WRAP.Geo.check(lineDash, strokeStyle, option);
      var color = this.set(feature);
      if (!color) return;

      var lw = lineWidth || 1;
      let d;
      for ( var j = 0 ; j < lines.length ; j++ ) {
        d = [];
        var line = lines[j];
        var x = line[0][0];
        var y = line[0][1];
        var i = 0;
        d.push(`M ${x}, ${y}`);
        while ( ++i < lines[j].length ) {
          x = line[i][0];
          y = line[i][1];
          d.push(`L ${x}, ${y}`);
        }
        if ( (fillStyle || fillImage)
          || (line[0][0] == line[line.length-1][0] && line[0][1] == line[line.length-1][1]) ) {
          d.push('Z');
        }
        let stroke = 'none';
        if (strokeStyle) {
          stroke = 'black';
        }
        let fill = 'none';
        if (fillStyle || fillImage) {
          fill = 'red';
        }
        const attr = [];
        attr.push(['stroke', stroke]);
        attr.push(['stroke-width', lw + 1]);
        attr.push(['stroke-linejoin', 'round']);
        attr.push(['fill', fill]);
        attr.push(['d', d.join(' ')]);
        attr.push(['feature', color]);
        this.ctx.push(
          `<path ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
        );
      }
    },

    _addFragments: function(lines, fragments) {
      var line = this.view.renderLine(fragments);
      for ( var i = 0 ; i < line.length ; i++ )
        lines.push(line[i]);
    },

    drawPath: function(feature, path, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option, method) {
      if ( !path || !path.length )
        return;
      var lines = [];
      var ll = Array.isArray(path[0][0])?[].concat(path):[path];
      for ( var i = 0 ; i < ll.length ; i++ ) {
        if ( ll[i].length < 2 )
          continue;
        var fragments = ll[i];
        if ( method != 'SL' )
          fragments = this._fragmentPath(method, ll[i]);
        this._addFragments(lines, fragments);
      }
      this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option);
    },

    drawArc: function(feature, point, radius, start, end, lineWidth, lineDash, strokeStyle, fillStyle, fillImage) {
      var path = [];
      var circle = false;
      if ( start == end || Math.abs(end-start) > 360 ) {
        var circle = true;
        start = 0;
        end = 360;
      }
      var step = 1;
      if ( radius < 500000 )
        step = 5;
      else if ( radius < 100000 )
        step = 2;
      radius /= 1851.8518518518517;
      for ( var r = start ; r < end ; r+=step ) {
        var pos = WRAP.Geo.Util.gcPos(point[1], point[0], r, radius);
        path.push([pos.lon, pos.lat]);
      }
      var pos = WRAP.Geo.Util.gcPos(point[1], point[0], end, radius);
      path.push([pos.lon, pos.lat]);
      
      if ( path.length < 2 )
        return;
      var lines = [];
      var fragments = this._fragmentPath('GC', path);
      this._addFragments(lines, fragments);
      if ( circle ) {
        this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, null);
      }
      else {
        if ( fillStyle || fillImage ) {
          var polygons = [];
          path.push(point);
          path.unshift(point);
          var fragments = this._fragmentPath('GC', path);
          this._addFragments(polygons, fragments);
          this._drawLines(feature, polygons, lineWidth, null, null, fillStyle, fillImage, null);
        }
        this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, null, null, null);
      }
    },

    drawPoint: function(feature, point, size) {
      var color = this.set(feature);
      if (!color) return;

      const _drawPoint = (ctx, ox, oy) => {
        const attr = [];
        attr.push(['cx', ox]);
        attr.push(['cy', oy]);
        attr.push(['r', size/2 - 1]);
        attr.push(['fill', 'red']);
        attr.push(['feature', color]);
        ctx.push(
          `<circle ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
        );
      }
    
      var p = this.view.renderPoint(point);
      var ctx = this.ctx;
          var ox = p[0];
      var oy = p[1];
      
      var sx = -size;
      var ex = this.svg.viewBox.baseVal.width+size;
      var sy = -size;
      var ey = this.svg.viewBox.baseVal.height+size;
      if ( oy < sy || ey < oy )
          return;
      if ( sx <= ox && ox <= ex ) {
        _drawPoint(ctx, ox, oy);
      }
      if ( this.view.band ) {
        var lox = ox - this.view.band;
        if ( sx <= lox && lox <= ex ) {
          _drawPoint(ctx, lox, oy);
        }
        var rox = ox + this.view.band;
        if ( sx <= rox && rox <= ex ) {
          _drawPoint(ctx, rox, oy);
        }
      }
    },

    drawLine: function(feature, point, path, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option, rotation) {
      var p = this.view.renderPoint(point);
      var ox = p[0];
      var oy = p[1];
      var cosr, sinr;
      if ( rotation ) {
          cosr = Math.cos(Math.PI*rotation/180.0);
          sinr = Math.sin(Math.PI*rotation/180.0);
      }
          
      var ll = Array.isArray(path[0][0])?[].concat(path):[path];
      var lines = [];
      for ( var j = 0 ; j < ll.length ; j++ ) {
          var p = ll[j];
          var line = [];
          var max_x = this.view.extent[0]*2;
          var min_x = -this.view.extent[0];
          var max_y = this.view.extent[1]*2;
          var min_y = -this.view.extent[1];
          for ( var i = 0 ; i < p.length ; i++ ) {
              var x = p[i][0];
              var y = p[i][1];
              if ( rotation ) {
                  var tx = x*cosr-y*sinr;
                  var ty = x*sinr+y*cosr;
                  x = tx, y = ty;
              }
              if ( min_x > x )
              min_x = x;
              if ( max_x < x )
                  max_x = x;
              if ( min_y> y )
                  min_y = y;
              if ( max_y < y )
                  max_y = y;
              line.push([x+ox, y+oy]);
          }
          var rr = this.view.wrapAround(line, this.view.extent[0], this.view.extent[1], this.view.band,
              min_x+ox, min_y+oy, max_x+ox, max_y+oy);
          lines = lines.concat(rr);
      }
      this._drawLines(feature, lines, lineWidth, lineDash, strokeStyle, fillStyle, fillImage, option);
    },

    drawText: function(feature, point, text, fontSize, fillStyle, strokeStyle, offset_x, offset_y, align, rotation) {
      WRAP.Geo.check(fillStyle);
      var color = this.set(feature);
      if (!color) return;
      
      const _drawText = (ctx, x, y, ox, oy, w, h) => {
        const attr = [];
        if ( rotation ) {
          const transform = [];
          transform.push(`rotate(${rotation}, ${x}, ${y})`);
          transform.push(`translate(${ox}, ${oy})`);
          if ( strokeStyle ) {
            x-=1, y-=1;
            w+=2, h+=2;
          }
          attr.push(['x', x]);
          attr.push(['y', y-h*0.8]);
          attr.push(['width', w]);
          attr.push(['height', h]);
          attr.push(['transform', transform.join(' ')]);
        } else {
          if ( strokeStyle ) {
            x-=1, y-=1;
            w+=2, h+=2;
          }
          attr.push(['x', x+ox]);
          attr.push(['y', y+oy-h*0.8]);
          attr.push(['width', w]);
          attr.push(['height', h]);
        }
        attr.push(['fill', 'pink']);
        attr.push(['feature', color]);
        ctx.push(
          `<rect ${attr.map(v => `${v[0]}="${v[1]}"`).join(' ')} />`
        )
      }
      
      var ctx = this.ctx;
      var ox = parseFloat(offset_x) || 0;
      var oy = parseFloat(offset_y) || 0;
      var a = WRAP.Geo.getTextMetrics(text, fontSize || 10);
      if ( align == 'left' ) {
        ox += 0;
      } else if ( align == 'right') {
        ox -= a[0];
      } else {
        ox -= a[0]*0.5;
      }
  
      var p = this.view.renderPoint(point);
      var x = p[0];
      var y = p[1];
      
      var size = a[0];
      var h = fontSize;
      var sx = -size-ox;
      var ex = this.svg.viewBox.baseVal.width+size-ox;
      var sy = -size;
      var ey = this.svg.viewBox.baseVal.height+size;
      if ( y < sy || ey <= y )
        return;
      if ( sx <= x && x <= ex ) {
        _drawText(ctx, x, y, ox, oy, size, h);
      }
      if ( this.view.band ) {
        var lx = x - this.view.band;
        if ( sx <= lx && lx <= ex ) {
          _drawText(ctx, lx, y, ox, oy, size, h);
        }
        var rx = x + this.view.band;
        if ( sx <= rx && rx <= ex ) {
          _drawText(ctx, rx, y, ox, oy, size, h);
        }
      }
    },

    drawTile: function(feature) {
      this.set(feature, true);
    },

    drawFlow: function(feature) {
      this.set(feature, true);
    },
  });

  WRAP.Renderer.GridValueExt = function() {
    WRAP.Renderer.call(this);

    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
        WRAP.Geo.check(dl);
        
        if ( !content )
            return;
        
        var content_changed = false;
        var valid = true;
        if ( this.context_revision != revision.context ) {
            valid = false;
        }
        
        if ( this.content_revision != revision.content ) {
            layer.clear();
            content_changed = true;
            valid = false;
        }
        
        if ( this.conf_revision != revision.conf ) {
            valid = false;
        }
        
        if ( this.style_revision != revision.style ) {
            valid = false;
        }
        
        if ( valid )
            return;
        
        var s = conf.Attributes.style.default;
        if ( style && conf.Attributes.style[style] )
            s = conf.Attributes.style[style];
        if ( !s ) {
            layer.setStatus({status:"error", reason:"style definition error."});
            return;
        }
        
        layer.setStatus({status:"invalid", reason:"data load waiting."});
        
        var bounds = [];
        for ( var i = 0 ; i < context.tiles.length ; i++ ) {
            var tile = context.tiles[i];
            bounds.push({
                north:tile.bounds.north/60,
                south:tile.bounds.south/60,
                west:tile.bounds.west/60,
                east:tile.bounds.east/60,
                tile:tile,                          // for TMS
                blocksize:(s.min_blocksize||16)     // for TMS
            })
        }

        var precision = 360/(256*Math.pow(2,Math.floor(context.zoom))) * (s.min_blocksize || 40);
        var sampling = "decimation "+precision.toFixed(4);

        var gpv = this.getGridValue(data, 'data', bounds, content, sampling, layer);
        if ( !gpv )
            return;
        
        var overlap_range = s.overlap_range || 0;
        var cross_fade = parseFloat(conf.Attributes.cross_fade);
        var data_scale = conf.Attributes.data_scale || 1;
        var data_offset = conf.Attributes.data_offset || 0;
        var digit = (s.fractional_digits===undefined)?1:parseInt(s.fractional_digits);
        var offsetX = s.offset_x || 0;
        var offsetY = s.offset_y || 0;

        var continuous = content_changed?null:dl;
        layer.clear();

        var index = 0;
        for ( var y = 0 ; y < gpv.height ; y++ ) {
            var lat = gpv.latBase-y*gpv.latInterval;
            if ( gpv.latCoordinates )
                lat = gpv.latCoordinates[y];
            for ( var x = 0 ; x < gpv.width ; x++ ) {
                var lon = gpv.lonBase+x*gpv.lonInterval;
                if ( gpv.gap && x > gpv.gap )
                    lon = gpv.gapBase+(x-gpv.gap-1)*gpv.lonInterval;
                lon = (lon+360)%360;
                var v = gpv.data[index++];
                if ( isNaN(v) )
                    continue;
                var st = 1;
                if ( overlap_range ) {
                    var lon_index = Math.round(lon/gpv.lonInterval);
                    var sp0 = WRAP.Geo.getScreenPoint(new WRAP.Geo.Point(lat*60, lon*60));
                    var sp1 = WRAP.Geo.getScreenPoint(new WRAP.Geo.Point(lat*60, (lon+gpv.lonInterval)*60));
                    var sp2 = WRAP.Geo.getScreenPoint(new WRAP.Geo.Point(lat*60, (lon-gpv.lonInterval)*60));
                    if ( isNaN(sp0.x) || isNaN(sp1.x) || isNaN(sp2.x) )
                        continue;
                    var dx1 = Math.abs(sp1.x-sp0.x);
                    var dy1 = Math.abs(sp1.y-sp0.y);
                    var dx2 = Math.abs(sp2.x-sp0.x);
                    var dy2 = Math.abs(sp2.y-sp0.y);
                    var dx = dx1<dx1?dx1:dx2;
                    var dy = dx1<dx1?dy1:dy2;
                    var len = Math.sqrt(dx*dx+dy*dy);
                    var t = Math.floor(overlap_range/len);
                    var tt = (t && Math.floor(Math.log2(t))) || 0;
                    st = Math.pow(2,tt);
                    if ( (lon_index % st) )
                        continue;
                }
                if ( gpv.gapBase !== undefined ) {
                    var ll = lon;
                    while ( gpv.gapBase <= ll )
                        ll -= 360;
                    if ( gpv.gapBase <= ll+st*gpv.lonInterval*0.3 )    // 30% wrap_around gap margin
                        continue;
                }
                var text = (v*data_scale+data_offset).toFixed(digit);
                var feature = null;
                if ( continuous ) {
                    for ( var k = 0 ; k < continuous.length ; k++ ) {
                        var f = continuous[k];
                        var fs = f.style();
                        if ( fs.point[0] == lon && fs.point[1] == lat && fs.text == text && fs.fillStyle == s.color) {
                            feature = f;
                            continuous.splice(k, 1);
                            break; 
                        }
                    }
                }
                if ( !feature ) {
                    feature = new WRAP.Geo.Feature.Text({
                        point:[lon,lat],
                        text:text,
                        fontSize:14,
                        fillStyle:s.color,
                        offsetX:offsetX,
                        offsetY:offsetY,
                        align:'center'
                    });
                }
                if ( cross_fade && !content_changed )
                    feature.fadeIn(cross_fade);
                layer.addFeature(feature);
                feature.geo = {
                    geometry: {
                        type:"Point",
                        coordinates:[lon,lat]
                    },
                    properties: {
                        grid_value: text
                    }
                }
            }
        }
        if ( continuous && cross_fade ) {
            for ( var k = 0 ; k < continuous.length ; k++ ) {
                var f = continuous[k];
                f.fadeOut(cross_fade);
                layer.addFeature(f);
            }
        }

        this.context_revision = revision.context;
        this.content_revision = revision.content;
        this.conf_revision = revision.conf;
        this.style_revision = revision.style;
        if ( layer.getStatus().status != 'error' )
            layer.setStatus({status:"valid"});
        WRAP.Geo.invalidate();
    }
  }
  /* eslint-enable */
}
